import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { BiX } from 'react-icons/bi';
import swal from 'sweetalert2';

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalBox = styled.div`
  background: white;
  border-radius: 16px;
  width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 32px;
  position: relative;
  animation: fadeIn 0.2s ease;
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const CloseBtn = styled.div`
  position: absolute;
  top: 20px; right: 20px;
  cursor: pointer;
`;

const Title = styled.h3`
  margin-bottom: 8px;
  font-size: 20px;
`;

const Desc = styled.p`
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 20px;
`;

const Label = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #6e6e73;
  margin-bottom: 6px;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px 12px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  margin-bottom: 16px;
  &:focus { border-color: #007aff; }
`;

const Arrow = styled.div`
  text-align: center;
  font-size: 24px;
  color: #9ca3af;
  margin: 4px 0 12px;
`;

const Btn = styled.button`
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  background: #ef4444;
  color: #fff;
  margin-top: 8px;
  &:hover { opacity: 0.85; }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;

const CompanyMergeModal = ({ companies, onClose }) => {
  const [sourceId, setSourceId] = useState('');
  const [targetId, setTargetId] = useState('');

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleMerge = async () => {
    if (!sourceId || !targetId) return;
    const sourceName = companies.find((c) => c._id === sourceId)?.name;
    const targetName = companies.find((c) => c._id === targetId)?.name;

    const result = await swal.fire({
      title: '회사 병합',
      html: `<b>${sourceName}</b>을(를) <b>${targetName}</b>에 병합합니다.<br><br>` +
        `${sourceName}의 소속 회원과 주문이 모두 ${targetName}으로 이동되고, ${sourceName}은 삭제됩니다.`,
      icon: 'warning',
      iconColor: '#d33',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#a3a3a3',
      confirmButtonText: '병합 실행',
      cancelButtonText: '취소',
    });

    if (result.isConfirmed) {
      try {
        const { data } = await axios.post('/admin/company/merge', { sourceId, targetId });
        swal.fire({ text: data.message, icon: 'success', showConfirmButton: false, timer: 1500 });
        onClose();
      } catch (err) {
        swal.fire({ text: err.response?.data?.message || '오류 발생', icon: 'error', showConfirmButton: false, timer: 1500 });
      }
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <ModalBox>
        <CloseBtn onClick={onClose}><BiX size={28} /></CloseBtn>
        <Title>회사 병합</Title>
        <Desc>원본 회사의 회원/주문을 대상 회사로 이동하고, 원본을 삭제합니다.</Desc>

        <Label>원본 (삭제될 회사)</Label>
        <Select value={sourceId} onChange={(e) => setSourceId(e.target.value)}>
          <option value="">선택하세요</option>
          {companies.filter((c) => c._id !== targetId).map((c) => (
            <option key={c._id} value={c._id}>{c.name} ({c.user_count}명)</option>
          ))}
        </Select>

        <Arrow>&darr;</Arrow>

        <Label>대상 (유지될 회사)</Label>
        <Select value={targetId} onChange={(e) => setTargetId(e.target.value)}>
          <option value="">선택하세요</option>
          {companies.filter((c) => c._id !== sourceId).map((c) => (
            <option key={c._id} value={c._id}>{c.name} ({c.user_count}명)</option>
          ))}
        </Select>

        <Btn onClick={handleMerge} disabled={!sourceId || !targetId || sourceId === targetId}>
          병합 실행
        </Btn>
      </ModalBox>
    </Overlay>
  );
};

export default CompanyMergeModal;
